var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-sm-row align-center"},[_c('img',{staticClass:"image",attrs:{"src":_vm.slice.primary.image.url,"alt":_vm.slice.primary.image.alt || 'Featured Image'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }